import { Link } from "react-router-dom";
import { Contact } from "../home/Home";
import { StandardJoin } from "../join us/Join";
import "./Contact.css";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Seo from "../../components/Seo/Seo";

function ConactUsPage() {
  const [t] = useTranslation("global");
  const [contact, setContact] = useState({});
  const [lang, setLang] = useState(localStorage.getItem("lang") || `"ar"`);

  useEffect(() => {
    const getContent = async () => {
      try {
        const response = await axios.get("/content");
        setContact(response?.data.contact);
      } catch (error) {
        toast.error(t("popups.error"));
      }
    };

    getContent();

    const handleStorageChange = () => {
      setLang(localStorage.getItem("lang") || `"ar"`);
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [t]);

  return (
    <>
      <Seo
        title="تواصل معنا"
        description="تواصل مع الرملاء للصناعات الخشبية لطلب استفسار أو عرض سعر لمشروعك القادم."
        path="/contact"
      />
      <section className="contact-us-page standardJoin">
      <StandardJoin>
        <div
          className="contact-page-eyebrow"
          data-aos={lang === `"en"` ? "fade-right" : "fade-left"}
          data-aos-duration="1000"
        >
          {t("contactus.start")}
        </div>
        <div className="join-heading-container">
          <h1
            data-aos={lang === `"en"` ? "fade-right" : "fade-left"}
            data-aos-duration="1400"
          >
            {lang === `"ar"` ? contact?.arMainText : contact?.mainText}
          </h1>
          <ul className="join-links">
            <Link to="https://www.linkedin.com/in/alramlaa-wooden-products-513276293/?skipRedirect=true">
              <li
                data-aos={lang === `"en"` ? "fade-left" : "fade-right"}
                data-aos-duration="1000"
              >
                <i className="fab fa-linkedin"></i>
              </li>
            </Link>
            <Link to="https://www.instagram.com/alramlaa.official/" target="_blank">
              <li
                data-aos={lang === `"en"` ? "fade-left" : "fade-right"}
                data-aos-duration="1200"
              >
                <i className="fa-brands fa-instagram"></i>
              </li>
            </Link>

            <Link to="https://www.facebook.com/people/Alramlaa-Wooden-Products/61583094580752/" target="_blank">
              <li
                data-aos={lang === `"en"` ? "fade-left" : "fade-right"}
                data-aos-duration="1400"
              >
                <i className="fa-brands fa-facebook"></i>
              </li>
            </Link>
          </ul>
        </div>
      </StandardJoin>
      <Contact variant="page" />
    </section>
    </>
  );
}

export default ConactUsPage;
